import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; 

@Component({
    selector: 'app-confirm-popup',
    templateUrl: './confirm-popup.component.html',
    styleUrls: ['./confirm-popup.component.css'],
    standalone: true,
    imports: [FormsModule],
})

export class ConfirmPopupComponent implements OnInit {

  comentarioSolucion: String = '';

  constructor(protected dialogRef: NbDialogRef<ConfirmPopupComponent>) { }

  ngOnInit(): void { }

  close(orden?: String) {
    if (orden === 'Solucion') {
      this.dialogRef.close(this.comentarioSolucion);
    } else {
      this.dialogRef.close();
    }
  }

}
